module.exports = __webpack_public_path__ + "img/svg/spinner.bee6a28aa037ce4fdede0bb597e9677d.svg";